import React from 'react';
import ActivityCard from '../../../../components/ActivityCard';
import { Grid } from '@material-ui/core';
import TicketBlock from '../../../activitycards/components/TicketBlock';

const ClientActivitiesGrid = ({ activities, handleItemClick }) => {
    return (
        <Grid container spacing={4} alignItems="stretch">
            {activities.map(activity => (
                <ActivityCard
                    key={activity.id}
                    activity={activity}
                    currentFilters={{
                        showEmpty: true
                    }}
                    comparisonEnabled={false}
                    onClick={() => handleItemClick(activity.id)}
                >
                    <TicketBlock activity={activity} isAdminOrAgent={true} showCommission={false} />
                </ActivityCard>
            ))}
        </Grid>
    );
};

export default ClientActivitiesGrid;
